module.exports = __webpack_public_path__ + "static/media/docs.0ce4e8aa.svg";